import { formatDate } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Tooltip } from 'chart.js';
import { Observable } from 'rxjs';
import { DataManipulationService } from 'src/app/services/data-manipulation.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-onboarding-categories',
  templateUrl: './onboarding-categories.component.html',
  styleUrls: ['./onboarding-categories.component.scss']
})
export class OnboardingCategoriesComponent implements OnInit {

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
      this.showStartDateContainer = false;
  }
  @Input() reportingDetails: any | null = null;
  @Input() chartDataForOnboarding!: any[];
  @Input() set reportingCategories(value: any) {
    this.getWorkspaceIntervals();
    if (this.teamFilterTimer) {
      setTimeout(() => {
        this.setCheckinCategories(value);
      }, 1500);
    } else {
      this.setCheckinCategories(value);
    }
  }

  @Input() set checkinStatements(value: any) {
    this.categoriesStatements = value;
    this.setStatementTab();
    this.statementResponses = [];
    this.getCategoryStatementScoreColor();
  }

  @Input() set stateResponses(value: any | undefined) {
    this.statementResponses = [];
    if (value !== undefined) {
      if (value.type === 'scaled') {
        this.getQuestionDistributionValues(value.responses);
      } else {
        this.statementResponses = value.responses._embedded.responses;
        this.statementResponseCount = value.responses._total_items;
        this.statementResponsePage = value.responses._page_count;
      }
    }
  }

  @Input() set reportingTeamsForFilter(value: any) {
    this.userTeams = value.teams || [];
    const teamFromUrl = this.getTeamFromUrl();
    if (teamFromUrl) {
      this.sortByTeam = teamFromUrl;
      this.defaultSelectedTeam = [teamFromUrl.uuid];
      if (!this.appliedTeamFromUrl && value.selectedTeam?.uuid !== teamFromUrl.uuid) {
        this.appliedTeamFromUrl = true;
        setTimeout(() => {
          this.selectTeamsForQuestions({ value: teamFromUrl });
        });
      } else {
        this.appliedTeamFromUrl = true;
      }
      return;
    }
    if (value.selectedTeam !== null && value.selectedTeam !== undefined) {
      this.sortByTeam = value.selectedTeam;
      this.defaultSelectedTeam.push(value.selectedTeam.uuid);
    }
  }

  @Input() set usersForFilter(value: any) {
    this.filterUsersForAssignee(value);
    this.applyUserFromUrl();
  }

  @Output() checkinStatementEvent = new EventEmitter<any>();
  @Output() statementResponsesEvent = new EventEmitter<any>();
  @Output() changedTeamEvent = new EventEmitter<any>();
  @Output() selectedUser = new EventEmitter<any>();
  @Output() selectedDateRange = new EventEmitter<any>();
  @Output() resetFilters = new EventEmitter<any>();

  checkinCategories: any[] = [];
  categoriesStatements: any[] = [];
  statementResponses: any[] = [];
  showSelectedTabState: any[] = [];
  defaultSelectedTeam: any[] = [];
  userTeams: any[] = [];
  usersForFilterDropdown: any[] = [];
  scoreColorInterval: any[] = [];

  previousShowSelectedTabCategIndex: any;
  showSelectedTabCateg: boolean[] = [];
  previousShowSelectedTabStateIndex: any;
  responseDistribution: any;
  showedOpenQsResponse: any;
  sortByTeam: any = null;
  userFilter: any;
  rangeDates: Date[] = [];

  hasCategoryStatements: boolean = false;
  showResponseModal: boolean = false;
  teamFilterTimer: boolean = false;
  showStartDateContainer: boolean = false;
  sumbitedDate: boolean = false;

  statementResponseCount: number = 0;
  statementResponsePage: number = 0;

  chartData: any[] = [];
  pollUuid: string | null = null;
  queryParams: { [key: string]: any } = {};
  private appliedTeamFromUrl = false;
  private appliedUserFromUrl = false;
  private appliedTabFromUrl = false;

  chartOptions = {
    plugins: {
      tooltip: {
        enabled: false
      },

    },
    elements : {
      arc : {
        borderColor: '#E6E6E6',
        borderWidth: 3,
      }
    }
  }


  constructor(public data: DataManipulationService, public translate: TranslateService,
              private activeRoute: ActivatedRoute) {
    this.pollUuid = this.activeRoute.snapshot.paramMap.get('pollUuid');
    this.queryParams = this.activeRoute.snapshot.queryParams;
  }

  ngOnInit(): void {
    this.initCategoryTabs();
  }

  private setCheckinCategories(value: any): void {
    this.checkinCategories = value || [];
    this.initCategoryTabs();
    this.applyTabFromUrl();
  }

  private initCategoryTabs(): void {
    this.showSelectedTabCateg = new Array(this.checkinCategories.length).fill(false);
  }

  private getTeamFromUrl(): any {
    const teamUuidFromUrl = this.queryParams['team'] || this.queryParams['teamUuid'];
    if (!teamUuidFromUrl || !this.userTeams.length) {
      return null;
    }
    return this.userTeams.find((team: any) => team.uuid === teamUuidFromUrl) || null;
  }

  private getUserFromUrl(): any {
    const userUuidFromUrl = this.queryParams['user'];
    if (!userUuidFromUrl || !this.usersForFilterDropdown.length) {
      return null;
    }
    return this.usersForFilterDropdown.find((user: any) => user.uuid === userUuidFromUrl) || null;
  }

  private applyTabFromUrl(): void {
    if (!this.appliedUserFromUrl || !this.getUserFromUrl()) {
      return;
    }
    const tabParam = this.queryParams['tab'];
    if (tabParam === undefined || tabParam === null || tabParam === '') {
      return;
    }
    const tabIndex = parseInt(tabParam, 10);
    if (isNaN(tabIndex) || tabIndex < 0 || tabIndex >= this.checkinCategories.length) {
      return;
    }
    const checkin = this.checkinCategories[tabIndex];
    this.showSelectedTabCateg[tabIndex] = true;
    this.showSelectedTabCateg = [...this.showSelectedTabCateg];
    this.previousShowSelectedTabCategIndex = tabIndex;
    this.appliedTabFromUrl = true;
    if (checkin) {
      this.hasCategoryStatements = false;
      this.categoriesStatements = [];
      this.checkinStatementEvent.emit(checkin);
    }
  }

  private applyUserFromUrl(): void {
    if (this.appliedUserFromUrl || !this.sortByTeam) {
      return;
    }
    const userFromUrl = this.getUserFromUrl();
    if (!userFromUrl) {
      return;
    }
    this.appliedUserFromUrl = true;
    this.userFilter = userFromUrl;
    setTimeout(() => {
      this.setFilterForUser({ value: userFromUrl });
    });
  }

  getWorkspaceIntervals() {
    //@ts-ignore
    const workspaceIntervals = JSON.parse(localStorage.getItem('WORKSPACE')).indicatorIntervals;
    this.scoreColorInterval = workspaceIntervals.map((interval: any) => ({
      min: interval.min,
      max: interval.max,
      //@ts-ignore
      color: interval.indicatorColor.color
    }));
  }

  filterUsersForAssignee(membersToAssign: any) {
    this.usersForFilterDropdown =
      membersToAssign
      .filter((member: any) => (member.status === 'active'))
      .map((member:any) => {
        return {name: member.detail.displayName ? member.detail.displayName :
                      member.detail.firstname ? member.detail.firstname + member.detail.lastname : member.email,
                uuid: member.uuid, avatar: member.avatar}});
    // this.usersForFilterDropdown.forEach((member:any, index:number) => {
    //   if (member.uuid === this.currentUser.uuid) {
    //     this.membersForSearch.splice(index, 1);
    //     this.membersForSearch.unshift(member);
    //   }
    // });
  }

  setStatementTab() {
    this.hasCategoryStatements = true;
    this.showSelectedTabState = new Array(this.categoriesStatements.length).fill(false);
  }

  getCategoryStatementScoreColor() {
    let statementScore = 0;
    this.categoriesStatements.forEach((statement: any) => {
      if (statement.question.eligibleForScore) {
        statementScore = statement.question.score;
        this.scoreColorInterval.forEach((scoreInterval: any) => {
          if (statementScore >= scoreInterval.min && statementScore <= scoreInterval.max) {
            statement.question.color = scoreInterval.color;
          }
        });
      } else {
        statement.question.color = 'default';
      }
    });
  }

  getQuestionDistributionValues(value: any) {
    if (value) {
      value.onInsight = true;
      value.eligibleForResult = true;
      this.responseDistribution = new Observable(subcriber => {
        subcriber.next(value);
      });
    }
  }

  openResponsePreviewModal(response: any) {
    this.showedOpenQsResponse = response;
    this.showResponseModal = true;
    const openModal = document.getElementById('actionModalButton');
    openModal?.click();
  }

  changePage(page: any, statementType: any, statementUuid: any, checkinUuid: string) {
    this.statementResponses = [];
    this.statementResponsesEvent.emit({statementType, statementUuid, checkinUuid, teamUuid: this.defaultSelectedTeam, page: page.page + 1, limit: 6});
  }

  emitStatementResponses(statementType: any, statementUuid: any, checkinUuid: string, index: number) {
    if (this.previousShowSelectedTabStateIndex === undefined) {
      this.previousShowSelectedTabStateIndex = index;
      this.showSelectedTabState[index] = true;
    } else {
      this.showSelectedTabState[this.previousShowSelectedTabStateIndex] = false;
      this.previousShowSelectedTabStateIndex = index;
      this.showSelectedTabState[index] = true;
    }
    this.statementResponsesEvent.emit({statementType, statementUuid, checkinUuid, teamUuid: this.defaultSelectedTeam, page: 1, limit: 6});
  }

  emitCategoryStatements(checkin: any, index: number) {
    const alreadyOpen = this.showSelectedTabCateg?.[index] === true
      && this.previousShowSelectedTabCategIndex === index;
    this.categoriesStatements = [];
    if (this.previousShowSelectedTabCategIndex === undefined) {
      this.previousShowSelectedTabCategIndex = index;
      this.showSelectedTabCateg[index] = true;
    } else if (this.previousShowSelectedTabCategIndex !== index) {
      this.showSelectedTabCateg[this.previousShowSelectedTabCategIndex] = false;
      this.previousShowSelectedTabCategIndex = index;
      this.showSelectedTabCateg[index] = true;
    } else {
      this.showSelectedTabCateg[index] = true;
    }
    this.showSelectedTabCateg = [...this.showSelectedTabCateg];
    this.hasCategoryStatements = false;
    if (!alreadyOpen) {
      this.checkinStatementEvent.emit(checkin);
    }
  }

  clearStatements() {
    this.statementResponses = [];
  }

  selectTeamsForQuestions(event: any) {
    this.defaultSelectedTeam = [];
    this.usersForFilterDropdown = [];
    this.userFilter = null;
    this.rangeDates = [];
    this.chartData = [];
    this.teamFilterTimer = true;
    if (event.value && event.value.uuid !== '') {
      this.defaultSelectedTeam.push(event.value.uuid);
    }
    this.changedTeamEvent.emit({changedTeamUuid: event.value !== null ? event.value?.uuid: '', isNonMembers: event.value !== null ? event.value.nonMembers : false});
    this.closeAllTabs();
  }

  closeAllTabs() {
    if (this.previousShowSelectedTabStateIndex !== undefined || this.previousShowSelectedTabCategIndex !== undefined) {
      this.showSelectedTabState[this.previousShowSelectedTabStateIndex] = false;
      this.showSelectedTabCateg[this.previousShowSelectedTabCategIndex] = false;
    }
  }

  setFilterForUser(user: any) {
    if (user.value) {
      this.selectedUser.emit(user.value.uuid);
    } else {
      this.selectedUser.emit(user.value);
    }
    this.closeAllTabs();
  }

  setDateRange() {
    this.selectedDateRange.emit(this.rangeDates.length? {startDate: formatDate(this.rangeDates[0],'dd.MM.yyyy', 'en-US'), endDate:formatDate(this.rangeDates[1],'dd.MM.yyyy', 'en-US')} : null);
    this.closeAllTabs();
  }

  clearDateRange() {
    this.rangeDates = [];
    this.sumbitedDate = false;
    this.selectedDateRange.emit(null);
    this.closeAllTabs();
  }

  clearFilters() {
    this.data.showLoading();
    this.rangeDates = [];
    this.sumbitedDate = false;
    this.userFilter = null;
    this.sortByTeam = null;
    this.resetFilters.emit();
    this.closeAllTabs();
  }

  showStartDate(event: any) {
    event?.stopPropagation();
    this.showStartDateContainer = true;
  }

  submitDateChanges() {
    this.hideStartDate();
    if (this.rangeDates.length) {
      this.sumbitedDate = true;
      this.setDateRange();
    }
  }

  hideStartDate() {
    event?.stopPropagation();
    this.showStartDateContainer = false;
  }

  cancelDateOptions() {
    event?.stopPropagation();
    this.clearDateOptions();
    this.showStartDateContainer = false;
  }

  clearDateOptions() {
    this.rangeDates = [];
    this.sumbitedDate = false;
  }
}
